<template>
    <div class="contain">
        <div class="top" >
            <div class="top_cover">
                <span class="cover_text">도전! 솔닥 다이어트 2023</span>
                 <span class="cover_sub_text">솔닥이 준비한 다이어트 퀴즈 풀고 선물 받아가세요!</span>
            </div>
        </div> 
        <div class="navBar">
            <div class="barElement">
                <span>앱 다운로드 없이 카카오톡으로, 쉽고 간편한 솔닥 비대면 진료</span>   
                <div class="button c7_head_btn" @click="gokakao">
                    진료실 바로가기
                </div>
            </div>
        </div>
        <img class="imgs" src="../../../assets/c7/diet_01.png" />
        <img class="imgs c7_ibtn1" @click="goEvent" src="../../../assets/c7/diet_02.png" />
        <img class="imgs" src="../../../assets/c7/diet_03.png" />
    </div>
</template>

<script>
export default {
    name: 'diet_event',
    methods: {
        goEvent: function()
        {
            window.open('https://doda.app/quiz/glVZWucm2G', '_blank');
        },
        gokakao: function()
        {
            window.criteo_q = window.criteo_q || [];
            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
            window.criteo_q.push(
                { event: "setAccount", account: 96598},

                // To Do 1. 현재 유저의 이메일 주소(공백 제거 및 소문자로 변환 후) 전달. 유저의 이메일을 알수 없는 상황이면 빈 문자열로 전달
                { event: "setEmail", email: "##User Email##" },

                // To Do 2. 현재 유저의 저장된 배송지 우편번호. 유저의 배송지 우편번호를 알수 없는 상황이면 빈 문자열로 전달
                { event: "setZipcode", zipcode: "##Zip Code##" },

                { event: "setSiteType", type: deviceType},

                // To Do 3. 확인 또는 주문 번호를 전달
                // Tip 1. 다른 종류의 전환일 경우 상품 ID에 다른 값으로 전달하여 나중에 리포트를 통해 확인 가능
                { event: "trackTransaction", id: Math.floor(Math.random()*99999999999), item: [
                    {id: "1", price: 1, quantity: 1 }
                ]}
            );

            window.open('https://tele.soldoc.co.kr/booking', '_blank');
        }
    }
}
</script>

<style scoped>
 .contain{
        width: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        min-width: 1200px
        /* display: flex;
        justify-content: center;
        align-content: center; */
        /* position: relative; */
        /* background: black; */
    }
    .top{
        max-height: 700px;
        min-height: 700px;
        width: 100%;
        /* min-width: 1200px; */
        background: url('../../../assets/c7/pc_top.jpg');
        background-size: cover;
        position: relative;
    }
    .top_cover{
        position: absolute;
        max-height: 700px;
        min-height: 700px;
        width: 100%;
        background: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .navBar{
        width: 100%;
        min-height: 80px;
        max-height: 80px;
        background: #FFFFFF;
        border-bottom: 1px solid #CCCCCC;
        display: flex;
        justify-content: center;
        align-items: center;
        /* background: blue; */
    }
    .barElement{
        width: 1200px;
        min-width: 1200px;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: 'Apple SD Gothic Neo';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 30px;
        color: #1A1A1A;
    }
    .button{
        width: 174px;
        height: 48px;
        background: #018DDC;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Apple SD Gothic Neo';
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 30px;
        cursor: pointer;
    }
    .cover_text{
        color: #ffffff;
        font-family : 'Noto Sans KR';
        font-size: 64px;
        font-weight: 500;
    }
    .cover_sub_text{
        color: #ffffff;
        font-family : 'Noto Sans KR';
        font-size: 22px;
        font-weight: 400;
        margin-top: 20px;
    }
    
    .c1_fbtn{
        position: fixed;
        bottom: 20px;
        right: 10px;
        width: 80px;
        z-index: 10;
        cursor: pointer;
    }
    .c7_ibtn1{
        cursor: pointer;
    }
    .c7_ibtn2{
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_view/contents/c7.vue